import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/step_1.png'
import _imports_1 from '@/assets/img/step_2.png'
import _imports_2 from '@/assets/img/step_3.png'
import _imports_3 from '@/assets/img/step_4.png'
import _imports_4 from '@/assets/img/image_3.jpg'

const _withId = /*#__PURE__*/_withScopeId("data-v-5476196f")

_pushScopeId("data-v-5476196f")
const _hoisted_1 = { id: "bodyWrap" }
const _hoisted_2 = { class: "linksPage" }
const _hoisted_3 = { class: "linksPageHeader" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "linksBanner" }
const _hoisted_6 = { class: "pageCaption" }
const _hoisted_7 = {
  class: "title font-prompt",
  style: {"font-size":"38px","letter-spacing":"1px","line-height":"60px"}
}
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { class: "textBlock" }
const _hoisted_10 = { style: {"font-size":"18px"} }
const _hoisted_11 = { class: "linksPageContent" }
const _hoisted_12 = { class: "stepsList" }
const _hoisted_13 = { class: "item" }
const _hoisted_14 = { class: "stepItem type1" }
const _hoisted_15 = { class: "num" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", {
  class: "img wow animate__animated animate__fadeInUp",
  "data-wow-offset": "0"
}, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: "step"
  })
], -1)
const _hoisted_17 = { class: "content" }
const _hoisted_18 = { class: "item" }
const _hoisted_19 = { class: "stepItem type2" }
const _hoisted_20 = { class: "num" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", {
  class: "img wow animate__animated animate__fadeInUp ",
  style: {"animation-delay":"0.5s"},
  "data-wow-delay": "0.5s",
  "data-wow-offset": "0"
}, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_1,
    alt: "step"
  })
], -1)
const _hoisted_22 = { class: "content" }
const _hoisted_23 = { class: "item" }
const _hoisted_24 = { class: "stepItem type3" }
const _hoisted_25 = { class: "num" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", {
  class: "img wow animate__animated animate__fadeInUp",
  style: {"animation-delay":"1s"},
  "data-wow-delay": "1s",
  "data-wow-offset": "0"
}, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    alt: "step"
  })
], -1)
const _hoisted_27 = { class: "content" }
const _hoisted_28 = { class: "item" }
const _hoisted_29 = { class: "stepItem type4" }
const _hoisted_30 = { class: "num" }
const _hoisted_31 = /*#__PURE__*/_createVNode("div", {
  class: "img wow animate__animated animate__fadeInUp",
  style: {"animation-delay":"1.5s"},
  "data-wow-delay": "1.5s",
  "data-wow-offset": "0"
}, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_3,
    alt: "step"
  })
], -1)
const _hoisted_32 = { class: "content" }
const _hoisted_33 = { class: "linkSectionBuy" }
const _hoisted_34 = { class: "container" }
const _hoisted_35 = { class: "wrapper" }
const _hoisted_36 = { class: "left" }
const _hoisted_37 = { class: "linkFormBuyWrapper" }
const _hoisted_38 = { class: "headBlock" }
const _hoisted_39 = { class: "title" }
const _hoisted_40 = { class: "subtitle" }
const _hoisted_41 = { class: "formBlock" }
const _hoisted_42 = { class: "radioWrap" }
const _hoisted_43 = { class: "label" }
const _hoisted_44 = { class: "radioList" }
const _hoisted_45 = { class: "radioBtn" }
const _hoisted_46 = /*#__PURE__*/_createVNode("input", {
  type: "radio",
  name: "type",
  id: "seller",
  checked: ""
}, null, -1)
const _hoisted_47 = { for: "seller" }
const _hoisted_48 = { class: "radioBtn" }
const _hoisted_49 = /*#__PURE__*/_createVNode("input", {
  type: "radio",
  name: "type",
  id: "buyer"
}, null, -1)
const _hoisted_50 = { for: "buyer" }
const _hoisted_51 = { class: "fieldsWrap" }
const _hoisted_52 = { class: "fieldItem" }
const _hoisted_53 = { class: "inBlockType3" }
const _hoisted_54 = { for: "buyerTerms" }
const _hoisted_55 = { class: "note" }
const _hoisted_56 = { class: "inWrap" }
const _hoisted_57 = { class: "fieldItem" }
const _hoisted_58 = { class: "inBlockType3" }
const _hoisted_59 = { for: "buyerLink" }
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "inWrap" }, [
  /*#__PURE__*/_createVNode("input", {
    type: "text",
    name: "buyerLink",
    id: "buyerLink",
    value: "https://www.moneyspace.net/merchantapi/makepaym…",
    readonly: ""
  })
], -1)
const _hoisted_61 = { class: "buttons" }
const _hoisted_62 = { class: "btnFillType6" }
const _hoisted_63 = { class: "right" }
const _hoisted_64 = { class: "linkInfo" }
const _hoisted_65 = { class: "titleBlock" }
const _hoisted_66 = { class: "subtitle invert" }
const _hoisted_67 = { class: "title invert" }
const _hoisted_68 = { class: "contentBlock" }
const _hoisted_69 = { class: "textBlock invert" }
const _hoisted_70 = { class: "linkDescr invert" }
const _hoisted_71 = { class: "item" }
const _hoisted_72 = { class: "cap" }
const _hoisted_73 = { class: "linkSectionMerch" }
const _hoisted_74 = { class: "container" }
const _hoisted_75 = { class: "wrapper" }
const _hoisted_76 = { class: "left" }
const _hoisted_77 = { class: "linkInfo" }
const _hoisted_78 = { class: "titleBlock" }
const _hoisted_79 = { class: "subtitle" }
const _hoisted_80 = {
  class: "title",
  style: {"font-size":"38px","letter-spacing":"1px","line-height":"60px"}
}
const _hoisted_81 = { class: "contentBlock" }
const _hoisted_82 = { class: "textBlock" }
const _hoisted_83 = { class: "linkDescr" }
const _hoisted_84 = { class: "item" }
const _hoisted_85 = { class: "cap" }
const _hoisted_86 = { class: "right" }
const _hoisted_87 = { class: "linkMerchFormWrapper" }
const _hoisted_88 = { class: "headBlock" }
const _hoisted_89 = { class: "title" }
const _hoisted_90 = { class: "subtitle" }
const _hoisted_91 = { class: "formBlock" }
const _hoisted_92 = { class: "fieldsWrap" }
const _hoisted_93 = { class: "fieldItem" }
const _hoisted_94 = { class: "inBlockType1" }
const _hoisted_95 = { for: "name" }
const _hoisted_96 = { class: "inWrap" }
const _hoisted_97 = { class: "fieldItem" }
const _hoisted_98 = { class: "inBlockType1" }
const _hoisted_99 = { for: "sum" }
const _hoisted_100 = { class: "inWrap" }
const _hoisted_101 = { class: "checkWrap" }
const _hoisted_102 = { class: "checkList" }
const _hoisted_103 = { class: "checkBtn" }
const _hoisted_104 = /*#__PURE__*/_createVNode("input", {
  type: "checkbox",
  name: "card",
  id: "card"
}, null, -1)
const _hoisted_105 = { for: "card" }
const _hoisted_106 = { class: "checkBtn" }
const _hoisted_107 = /*#__PURE__*/_createVNode("input", {
  type: "checkbox",
  name: "plan",
  id: "plan"
}, null, -1)
const _hoisted_108 = { for: "plan" }
const _hoisted_109 = { class: "radioWrap" }
const _hoisted_110 = { class: "label" }
const _hoisted_111 = { class: "radioList" }
const _hoisted_112 = { class: "radioBtn invert" }
const _hoisted_113 = /*#__PURE__*/_createVNode("input", {
  type: "radio",
  name: "typeMerch",
  id: "sellerMerch",
  checked: ""
}, null, -1)
const _hoisted_114 = { for: "sellerMerch" }
const _hoisted_115 = { class: "radioBtn invert" }
const _hoisted_116 = /*#__PURE__*/_createVNode("input", {
  type: "radio",
  name: "typeMerch",
  id: "buyerMerch"
}, null, -1)
const _hoisted_117 = { for: "buyerMerch" }
const _hoisted_118 = { class: "fieldsWrap" }
const _hoisted_119 = { class: "fieldItem" }
const _hoisted_120 = { class: "inBlockType1" }
const _hoisted_121 = {
  for: "buyerTerms",
  class: "lg"
}
const _hoisted_122 = { class: "note" }
const _hoisted_123 = { class: "inWrap" }
const _hoisted_124 = { class: "more" }
const _hoisted_125 = {
  href: "#",
  class: "btnSimpleType2"
}
const _hoisted_126 = /*#__PURE__*/_createVNode("span", { class: "line" }, null, -1)
const _hoisted_127 = { class: "btnFillType2 full" }
const _hoisted_128 = { class: "joinSection links" }
const _hoisted_129 = { class: "container" }
const _hoisted_130 = { class: "joinBlock lg" }
const _hoisted_131 = /*#__PURE__*/_createVNode("div", { class: "img" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_4,
    alt: "image"
  })
], -1)
const _hoisted_132 = {
  class: "info",
  style: {"margin-left":"200px"}
}
const _hoisted_133 = {
  href: "#",
  class: "btnIconType1 sm"
}
const _hoisted_134 = { class: "in" }
const _hoisted_135 = { class: "text" }
const _hoisted_136 = /*#__PURE__*/_createVNode("span", { class: "icon-arrow" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Header = _resolveComponent("Header")
  const _component_Footer = _resolveComponent("Footer")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("span", _hoisted_7, _toDisplayString(_ctx.t("linksPage.info")), 1)
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode("div", _hoisted_9, [
                _createVNode("p", _hoisted_10, _toDisplayString(_ctx.t("linksPage.title")), 1)
              ])
            ])
          ])
        ])
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _createVNode("div", _hoisted_14, [
              _createVNode("span", _hoisted_15, _toDisplayString(_ctx.t("linksPage.steps[0].id")), 1),
              _hoisted_16,
              _createVNode("div", _hoisted_17, [
                _createVNode("p", null, _toDisplayString(_ctx.t("linksPage.steps[0].content")), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, [
              _createVNode("span", _hoisted_20, _toDisplayString(_ctx.t("linksPage.steps[1].id")), 1),
              _hoisted_21,
              _createVNode("div", _hoisted_22, [
                _createVNode("p", null, _toDisplayString(_ctx.t("linksPage.steps[1].content")), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_23, [
            _createVNode("div", _hoisted_24, [
              _createVNode("span", _hoisted_25, _toDisplayString(_ctx.t("linksPage.steps[2].id")), 1),
              _hoisted_26,
              _createVNode("div", _hoisted_27, [
                _createVNode("p", null, _toDisplayString(_ctx.t("linksPage.steps[2].content")), 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_28, [
            _createVNode("div", _hoisted_29, [
              _createVNode("span", _hoisted_30, _toDisplayString(_ctx.t("linksPage.steps[3].id")), 1),
              _hoisted_31,
              _createVNode("div", _hoisted_32, [
                _createVNode("p", null, _toDisplayString(_ctx.t("linksPage.steps[3].content")), 1)
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_33, [
          _createVNode("div", _hoisted_34, [
            _createVNode("div", _hoisted_35, [
              _createVNode("div", _hoisted_36, [
                _createVNode("div", _hoisted_37, [
                  _createVNode("div", {
                    class: [[_ctx.isFormBuyActive() ? ['visible', 'wow', 'animate__animated', 'animate__bounceInLeft'] : ['visible', 'wow', 'animate__animated', 'animate__bounceOutLeft']], "linkFormBuy"],
                    "data-wow-delay": "0.2s"
                  }, [
                    _createVNode("div", _hoisted_38, [
                      _createVNode("span", _hoisted_39, _toDisplayString(_ctx.t("linksPage.linkSectionBuy.left.title")), 1),
                      _createVNode("span", _hoisted_40, _toDisplayString(_ctx.t("linksPage.linkSectionBuy.left.subtitle")), 1)
                    ]),
                    _createVNode("div", _hoisted_41, [
                      _createVNode("div", _hoisted_42, [
                        _createVNode("span", _hoisted_43, _toDisplayString(_ctx.t("linksPage.linkSectionBuy.left.radioWrap.label")), 1),
                        _createVNode("ul", _hoisted_44, [
                          _createVNode("li", null, [
                            _createVNode("div", _hoisted_45, [
                              _hoisted_46,
                              _createVNode("label", _hoisted_47, _toDisplayString(_ctx.t("linksPage.linkSectionBuy.left.radioWrap.radioList.seller")), 1)
                            ])
                          ]),
                          _createVNode("li", null, [
                            _createVNode("div", _hoisted_48, [
                              _hoisted_49,
                              _createVNode("label", _hoisted_50, _toDisplayString(_ctx.t("linksPage.linkSectionBuy.left.radioWrap.radioList.buyer")), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_51, [
                        _createVNode("div", _hoisted_52, [
                          _createVNode("div", _hoisted_53, [
                            _createVNode("label", _hoisted_54, [
                              _createTextVNode(_toDisplayString(_ctx.t("linksPage.linkSectionBuy.left.fieldsWrap.label1")) + " ", 1),
                              _createVNode("span", _hoisted_55, _toDisplayString(_ctx.t("linksPage.linkSectionBuy.left.fieldsWrap.label2")), 1)
                            ]),
                            _createVNode("div", _hoisted_56, [
                              _createVNode("input", {
                                type: "text",
                                class: "terms",
                                name: "buyerTerms",
                                id: "buyerTerms",
                                value: _ctx.t('linksPage.linkSectionBuy.left.fieldsWrap.placeHolder'),
                                readonly: ""
                              }, null, 8, ["value"])
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_57, [
                          _createVNode("div", _hoisted_58, [
                            _createVNode("label", _hoisted_59, _toDisplayString(_ctx.t("linksPage.linkSectionBuy.left.fieldsWrap.buyerLink")), 1),
                            _hoisted_60
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_61, [
                        _createVNode("span", _hoisted_62, _toDisplayString(_ctx.t("linksPage.linkSectionBuy.left.fieldsWrap.copyLink")), 1)
                      ])
                    ])
                  ], 2)
                ])
              ]),
              _createVNode("div", _hoisted_63, [
                _createVNode("div", _hoisted_64, [
                  _createVNode("div", _hoisted_65, [
                    _createVNode("span", _hoisted_66, _toDisplayString(_ctx.t("linksPage.linkSectionBuy.right.subtitle")), 1),
                    _createVNode("span", _hoisted_67, _toDisplayString(_ctx.t("linksPage.linkSectionBuy.right.title")), 1)
                  ]),
                  _createVNode("div", _hoisted_68, [
                    _createVNode("div", _hoisted_69, [
                      _createVNode("p", null, _toDisplayString(_ctx.t("linksPage.linkSectionBuy.right.textBlock")), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_70, [
                  _createVNode("div", _hoisted_71, [
                    _createVNode("span", _hoisted_72, _toDisplayString(_ctx.t("linksPage.linkSectionBuy.right.items[0].cap")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.t("linksPage.linkSectionBuy.right.items[0].content")), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_73, [
          _createVNode("div", _hoisted_74, [
            _createVNode("div", _hoisted_75, [
              _createVNode("div", _hoisted_76, [
                _createVNode("div", _hoisted_77, [
                  _createVNode("div", _hoisted_78, [
                    _createVNode("span", _hoisted_79, _toDisplayString(_ctx.t("linksPage.linkSectionMerch.left.subtitle")), 1),
                    _createVNode("span", _hoisted_80, _toDisplayString(_ctx.t("linksPage.linkSectionMerch.left.title")), 1)
                  ]),
                  _createVNode("div", _hoisted_81, [
                    _createVNode("div", _hoisted_82, [
                      _createVNode("p", null, _toDisplayString(_ctx.t("linksPage.linkSectionMerch.left.textBlock")), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_83, [
                  _createVNode("div", _hoisted_84, [
                    _createVNode("span", _hoisted_85, _toDisplayString(_ctx.t("linksPage.linkSectionMerch.left.items[0].cap")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.t("linksPage.linkSectionMerch.left.items[0].content1")), 1),
                    _createVNode("p", null, _toDisplayString(_ctx.t("linksPage.linkSectionMerch.left.items[0].content2")), 1)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_86, [
                _createVNode("div", _hoisted_87, [
                  _createVNode("div", {
                    class: [[_ctx.isMerchFormActive() ? ['visible', 'wow', 'animate__animated', 'animate__bounceInRight'] : ['visible', 'wow', 'animate__animated', 'animate__bounceOutRight']], "linkMerchForm"],
                    "data-wow-delay": "0.2s"
                  }, [
                    _createVNode("div", _hoisted_88, [
                      _createVNode("span", _hoisted_89, _toDisplayString(_ctx.t("linksPage.linkSectionMerch.right.title")), 1),
                      _createVNode("span", _hoisted_90, _toDisplayString(_ctx.t("linksPage.linkSectionMerch.right.subtitle")), 1)
                    ]),
                    _createVNode("div", _hoisted_91, [
                      _createVNode("div", _hoisted_92, [
                        _createVNode("div", _hoisted_93, [
                          _createVNode("div", _hoisted_94, [
                            _createVNode("label", _hoisted_95, _toDisplayString(_ctx.t("linksPage.linkSectionMerch.right.items[0].label")), 1),
                            _createVNode("div", _hoisted_96, [
                              _createVNode("input", {
                                type: "text",
                                name: "name",
                                id: "name",
                                value: _ctx.t('linksPage.linkSectionMerch.right.items[0].placeholder')
                              }, null, 8, ["value"])
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_97, [
                          _createVNode("div", _hoisted_98, [
                            _createVNode("label", _hoisted_99, _toDisplayString(_ctx.t("linksPage.linkSectionMerch.right.items[1].label")), 1),
                            _createVNode("div", _hoisted_100, [
                              _createVNode("input", {
                                type: "text",
                                name: "sum",
                                id: "sum",
                                value: _ctx.t('linksPage.linkSectionMerch.right.items[1].placeholder')
                              }, null, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_101, [
                        _createVNode("ul", _hoisted_102, [
                          _createVNode("li", null, [
                            _createVNode("div", _hoisted_103, [
                              _hoisted_104,
                              _createVNode("label", _hoisted_105, _toDisplayString(_ctx.t("linksPage.linkSectionMerch.right.checkList[0].label")), 1)
                            ])
                          ]),
                          _createVNode("li", null, [
                            _createVNode("div", _hoisted_106, [
                              _hoisted_107,
                              _createVNode("label", _hoisted_108, _toDisplayString(_ctx.t("linksPage.linkSectionMerch.right.checkList[1].label")), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_109, [
                        _createVNode("span", _hoisted_110, _toDisplayString(_ctx.t("linksPage.linkSectionMerch.right.radioWrap.label")), 1),
                        _createVNode("ul", _hoisted_111, [
                          _createVNode("li", null, [
                            _createVNode("div", _hoisted_112, [
                              _hoisted_113,
                              _createVNode("label", _hoisted_114, _toDisplayString(_ctx.t("linksPage.linkSectionMerch.right.radioWrap.radioList[0].label")), 1)
                            ])
                          ]),
                          _createVNode("li", null, [
                            _createVNode("div", _hoisted_115, [
                              _hoisted_116,
                              _createVNode("label", _hoisted_117, _toDisplayString(_ctx.t("linksPage.linkSectionMerch.right.radioWrap.radioList[1].label")), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_118, [
                        _createVNode("div", _hoisted_119, [
                          _createVNode("div", _hoisted_120, [
                            _createVNode("label", _hoisted_121, [
                              _createTextVNode(_toDisplayString(_ctx.t("linksPage.linkSectionMerch.right.fieldsWrap.label1")) + " ", 1),
                              _createVNode("span", _hoisted_122, _toDisplayString(_ctx.t("linksPage.linkSectionMerch.right.fieldsWrap.label2")), 1)
                            ]),
                            _createVNode("div", _hoisted_123, [
                              _createVNode("input", {
                                type: "text",
                                class: "terms",
                                name: "buyerTerms",
                                id: "buyerTerms",
                                value: _ctx.t('linksPage.linkSectionMerch.right.fieldsWrap.placeHolder'),
                                readonly: ""
                              }, null, 8, ["value"])
                            ])
                          ])
                        ])
                      ]),
                      _createVNode("div", _hoisted_124, [
                        _createVNode("a", _hoisted_125, _toDisplayString(_ctx.t("linksPage.linkSectionMerch.right.more.link")), 1),
                        _hoisted_126
                      ]),
                      _createVNode("button", _hoisted_127, _toDisplayString(_ctx.t("linksPage.linkSectionMerch.right.more.buttonValue")), 1)
                    ])
                  ], 2)
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_128, [
          _createVNode("div", _hoisted_129, [
            _createVNode("div", _hoisted_130, [
              _hoisted_131,
              _createVNode("div", _hoisted_132, [
                _createVNode("span", {
                  class: "title sm mb-md-4",
                  style: {"line-height":"1.4 !important"},
                  innerHTML: _ctx.$t('linksPage.joinSection.info')
                }, null, 8, ["innerHTML"]),
                _createVNode("a", _hoisted_133, [
                  _createVNode("span", _hoisted_134, [
                    _createVNode("span", _hoisted_135, _toDisplayString(_ctx.$t("linksPage.joinSection.link")), 1),
                    _hoisted_136
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Footer)
  ]))
})